@file:Suppress("DEPRECATION")
package org.example.newportfolio.components.sections.start.components

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.animation.Keyframes
import com.varabyte.kobweb.silk.components.animation.toAnimation
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.*

val StartSectionGridKeyFrames by Keyframes {
    0.percent {
        Modifier
            .margin(right = 50.px)
            .opacity(0)
    }
    100.percent {
        Modifier
            .margin(right = 0.px)
            .opacity(1)
    }
}

val StartSectionGridStyle by ComponentStyle(extraModifiers = {
    Modifier.animation(
        StartSectionGridKeyFrames.toAnimation(
            duration = 0.5.s,
            timingFunction = AnimationTimingFunction.EaseInOut
        )
    )
}) {
    base {
        Modifier
            .width(100.percent)
            .display(DisplayStyle.Flex)
            .columnGap(1.cssRem)
            .rowGap(3.cssRem)
            // Stack above the absolutely-positioned `.hero-orbs` div that
            // the StartSection injects as a background layer.
            .position(Position.Relative)
            .zIndex(1)
    }
    // Per-breakpoint rowGap overrides the 3rem base. 48px between the stacked
    // photo and the title is desktop-sized; on a phone it opens an oversized
    // gap and inflates total height. Tighter values read more deliberate.
    Breakpoint.ZERO {
        Modifier.flexDirection(FlexDirection.ColumnReverse).rowGap(20.px)
    }
    Breakpoint.SM {
        Modifier.flexDirection(FlexDirection.ColumnReverse).rowGap(24.px)
    }
    Breakpoint.MD {
        Modifier.flexDirection(FlexDirection.ColumnReverse).rowGap(32.px)
    }
    Breakpoint.LG {
        Modifier.flexDirection(FlexDirection.Row)
    }
    Breakpoint.XL {
        Modifier.flexDirection(FlexDirection.Row)
    }
}